import React, { useMemo, useState } from 'react';
import { useThemeContext } from '../contexts/ThemeContext';

export type GhostButtonIcon = {
  default: string;
  hover: string;
};

export const useGhostButtonProps = (icon: GhostButtonIcon) => {
  const { theme } = useThemeContext();
  const [isHovered, setIsHovered] = useState(false);

  const props = useMemo(() => {
    const actionButtonBaseSx = {
      borderRadius: '100px',
      textTransform: 'none' as const,
      fontWeight: 500,
      fontSize: '14px',
      height: '48px',
      alignItems: 'center',
      gap: '8px',
      padding: '0 24px',
    };

    const sxProps = {
      ...actionButtonBaseSx,
      color: theme.buttons.ghost.color,
      border: 'none',
      backgroundColor: 'transparent',
      '&:hover': {
        background: 'transparent',
        color: theme.buttons.ghost.hover.color,
        border: 'none',
      },
      marginTop: '0px',
      padding: '0px',
    };

    const currentIconSrc = isHovered ? icon.hover : icon.default;

    const additionalProps = {
      style: { border: 'none', height: '48px', borderRadius: '100px' },
      startIcon: (
        <img
          src={currentIconSrc}
          alt="icon"
          width={24}
          height={24}
          style={{ objectFit: 'contain' }}
        />
      ),
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
    };

    return { sxProps, additionalProps };
  }, [theme, icon, isHovered]);

  return props;
};
